import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum InterpreterEnum {
    None = 0,
    Family = 1,
    Friend = 2,
    "Professional Interpreter Service Requested" = 4,
    Other = 8
}

export class PalConvertToPendingInterpreter extends EnumWithDescription<InterpreterEnum> {
    public readonly enum = Interpreter;
    public readonly enumName: string = "Interpreter";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<InterpreterEnum>> = new Map([
        [
            "None",
            {
                value: InterpreterEnum.None,
                name: "None"
            }
        ],
        [
            "Family",
            {
                value: InterpreterEnum.Family,
                name: "Family"
            }
        ],
        [
            "Friend",
            {
                value: InterpreterEnum.Friend,
                name: "Friend"
            }
        ],
        [
            "Professional Interpreter Service Requested",
            {
                value: InterpreterEnum["Professional Interpreter Service Requested"],
                name: "Professional Interpreter Service Requested"
            }
        ],
        [
            "Other",
            {
                value: InterpreterEnum.Other,
                name: "Other"
            }
        ]
    ]);
}

export const Interpreter = new PalConvertToPendingInterpreter();
